import React, { useState, useEffect } from "react";
import AdminSideBar from "../admin-page/AdminSideBar";
import "./reports.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllAttendanceReportApi,
  exportAttendanceReportCsvApi,
  exportAttendanceReportPdfApi,
} from "../../redux/apiCalls/attendanceApiCall";
import { getAllUserApi } from "../../redux/apiCalls/profileApiCall";

function Reports() {
  const dispatch = useDispatch();
  const { attendanceReport, loading, error } = useSelector(
    (state) => state.attendance
  );
  const { profiles } = useSelector((state) => state.profile);
  const {user} = useSelector(state => state.auth);


  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [userId, setUserId] = useState(""); 
  const [department, setDepartment] = useState(""); 

// Load all users for dropdown (only if admin)
useEffect(() => {
  if (user?.isAdmin) {
    dispatch(getAllUserApi());
  }
}, [dispatch, user]);

  // Fetch JSON attendance report with filters
  const handleViewReport = () => {
    dispatch(
      getAllAttendanceReportApi({
        startDate,
        endDate,
        userId,
        department,
      })
    );
  };

  const handleExportCSV = () => {
    dispatch(
      exportAttendanceReportCsvApi({
        startDate,
        endDate,
        userId,
        department,
      })
    );
  };

  const handleExportPDF = () => {
    dispatch(
      exportAttendanceReportPdfApi({
        startDate,
        endDate,
        userId,
        department,
      })
    );
  };

  // Extract unique departments dynamically
  const uniqueDepartments = profiles
    ? [...new Set(profiles.map((user) => user.department))].filter(Boolean)
    : [];

  return (
    <main className="admin-page">
      <div className="admin-layout">
        <AdminSideBar />

        <section className="admin-main">
          <header className="admin-main-header">
            <h2 className="admin-main-title">Attendance Reports</h2>
            <p className="admin-main-subtitle">
              View attendance logs and export reports.
            </p>
          </header>

          {/* ===== Filters ===== */}
          <div className="report-filters">
            <div className="filter-group">
              <label>Start Date</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>

            <div className="filter-group">
              <label>End Date</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
{user?.isAdmin && ( <>
  <div className="filter-group">
              <label>User</label>
              <select
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
              >
                <option value="">All Users</option>
                {profiles &&
                  profiles.map((user) => (
                    <option key={user._id} value={user._id}>
                      {user.userName}
                    </option>
                  ))}
              </select>
            </div>

            <div className="filter-group">
              <label>Department</label>
              <select
                value={department}
                onChange={(e) => setDepartment(e.target.value)}
              >
                <option value="">All Departments</option>
                {uniqueDepartments.map((dept) => (
                  <option key={dept} value={dept}>
                    {dept}
                  </option>
                ))}
              </select>
            </div>


</> )}
            

            <div className="filter-actions">
              <button className="btn primary" onClick={handleViewReport}>
                View Report
              </button>
              <button className="btn success" onClick={handleExportCSV}>
                Export CSV
              </button>
              <button className="btn danger" onClick={handleExportPDF}>
                Export PDF
              </button>
            </div>
          </div>

          {/* ===== Loading / Error ===== */}
          {loading && <p>Loading...</p>}
          {error && <p style={{ color: "red" }}>{error}</p>}

          {/* ===== Table ===== */}
          <table className="report-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>User</th>
                <th>Email</th>
                <th>Department</th>
                <th>Check In</th>
                <th>Check Out</th>
                <th>Total Hours</th>
                <th>Work Type</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {attendanceReport && attendanceReport.length > 0 ? (
                attendanceReport.map((att, index) => (
                  <tr key={index}>
                    <td>{new Date(att.Date).toLocaleDateString()}</td>
                    <td>{att.User}</td>
                    <td>{att.Email}</td>
                    <td>{att.Department}</td>
                    <td>{att["Check In"]}</td>
                    <td>{att["Check Out"]}</td>
                    <td>{att["Total Hours"]}</td>
                    <td>{att.WorkType}</td>
                    <td>{att.Status === "Weekend" ? "Weekend" : att.Status}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center" }}>
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </section>
      </div>
    </main>
  );
}

export default Reports;
